import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
    name: 'CmgRetroCreditLanding',
})
export default class CmgRetroCreditLanding extends Vue {
    get isSignedIn(): boolean {
        return !!this.$appStore.state.customer.profile && !this.$appStore.state.customer.profile.isGuest;
    }

    async mounted() {
        await this.$services.config.setLegalText();
    }

    onClickSignIn(event: any) {
        this.$services.ui.pushEventTargetAsLastSelectedElement(event);
        this.$services.ui.setModalVisibility('signIn', true);
        this.$services.ui.firstFocus();
    }

    onClickStart() {
        this.$services.ui.nextFocus('retro-credit-title');        
        this.emitStart();
    }

    private emitStart() {
        this.$emit('start');
    }
}
